"use client"

import { useQuery } from "@tanstack/react-query"

import { fetchFinanceHome, fetchMembersHome } from "@/features/dashboard/home-d4/services/home-dashboard-api"
import { homeDashboardQueryKeys } from "@/features/dashboard/home-d4/services/home-dashboard-query-keys"

type Scope = { workspaceId: string | null | undefined; branchId: string | null | undefined }

export function useFinanceHomeQuery(
  scope: Scope & { dateFrom: string; dateTo: string },
  options: { enabled: boolean },
) {
  return useQuery({
    queryKey: homeDashboardQueryKeys.finance(scope.workspaceId, scope.branchId, scope),
    queryFn: () =>
      fetchFinanceHome({
        workspaceId: scope.workspaceId ?? "",
        branchId: scope.branchId ?? "",
        dateFrom: scope.dateFrom,
        dateTo: scope.dateTo,
      }),
    enabled:
      options.enabled && Boolean(scope.workspaceId) && Boolean(scope.branchId) && Boolean(scope.dateFrom && scope.dateTo),
    // A refused read (403) will be refused again: the tile hides instead of retrying.
    retry: false,
  })
}

export function useMembersHomeQuery(scope: Scope, options: { enabled: boolean }) {
  return useQuery({
    queryKey: homeDashboardQueryKeys.members(scope.workspaceId, scope.branchId),
    queryFn: () => fetchMembersHome({ workspaceId: scope.workspaceId ?? "", branchId: scope.branchId ?? "" }),
    enabled: options.enabled && Boolean(scope.workspaceId) && Boolean(scope.branchId),
    retry: false,
  })
}
